module.exports = __webpack_public_path__ + "media/dogs/puppy-dog-avatar-2ba0dad8.svg";